import { styled } from "@mui/material";

import { Select as UnstyledSelect } from "@citrine/atoms/select";
import type { CatalystMode } from "@citrine/types/full-story";

interface SelectProps {
  mode: CatalystMode;
}

export const Select = styled(UnstyledSelect, {
  shouldForwardProp: (propName: keyof SelectProps) => propName !== "mode",
})<SelectProps>(({ theme, mode }) => {
  const backgroundColor =
    mode === "model-expert"
      ? theme.palette.predictor.light
      : theme.palette.info.light;

  return {
    "& .MuiInputBase-root": {
      backgroundColor,
      borderRadius: theme.spacing(1.5),
      height: theme.spacing(3),
      ":hover": {
        backgroundColor,
      },

      "&.MuiSelect-filled": {
        paddingRight: theme.spacing(3),
      },
      "&.Mui-focused": {
        backgroundColor,
      },
    },

    "& .MuiInputBase-formControl": {
      fontSize: theme.spacing(1.5),
      letterSpacing: "0.5px",
    },

    "& .MuiSelect-select": {
      gap: theme.spacing(0.5),
      "&&&": {
        padding: theme.spacing(0, 3, 0, 0.75),
      },
      ":focus": {
        backgroundColor: "initial",
      },
    },

    "& .MuiSelect-iconFilled": {
      right: 0,
    },
  };
});
